/**
 * --------------------------------------------------
 * components/ShopLocalization.ts
 *
 * - Support multiple markets, currencies and languages
 * - Dependencies: Shopify Markets & Geolocation App
    - https://help.shopify.com/en/manual/markets
    - https://apps.shopify.com/geolocation
 * --------------------------------------------------
*/

import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import Search from 'iso-country-currency';
import 'currency-flags/dist/currency-flags.css';

@Component
export class ShopLocalization extends ThemeComponent {
    @Ref({ required: false }) flag!: HTMLSpanElement;
    @Ref panel!: HTMLUListElement;

    init() {
        this.addEventListeners();
    }

    private addEventListeners() {
        this.panel.addEventListener('change', () => {
            this.panel.closest('form')?.submit();
        });
    }
}
